/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Published_ToInputs */

const cs_blog_filter_published_to = /** @type {(inputs: Blog_Filter_Published_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno do`)
};

const en_blog_filter_published_to = /** @type {(inputs: Blog_Filter_Published_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published to`)
};

/**
* | output |
* | --- |
* | "Published to" |
*
* @param {Blog_Filter_Published_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_published_to = /** @type {((inputs?: Blog_Filter_Published_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Published_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_published_to(inputs)
	return cs_blog_filter_published_to(inputs)
});